import React, { FunctionComponent } from 'react';

import { useUnit } from 'effector-react/ssr';

import { $dialogs, setIsOpenFeedback, setIsOpenFeedbackSuccess } from '@stores/dialogs';

import { Dialog } from '@components/common/Dialog/Dialog';
import { FeedbackForm } from '@components/forms/FeedbackFrom/FeedbackFrom';

import styles from './FeedbackDialog.module.scss';

const formId = 'feedback-form-modal';

export const FeedbackDialog: FunctionComponent = () => {
    const [{ isOpenFeedback }, setIsOpenFeedbackFn] = useUnit([$dialogs, setIsOpenFeedback]);
    const setIsOpenFeedbackSuccessFn = useUnit(setIsOpenFeedbackSuccess);

    return (
        <Dialog isOpen={isOpenFeedback} setOpen={setIsOpenFeedbackFn} title="Задать вопрос">
            <FeedbackForm
                formId={formId}
                className={styles.form}
                onSubmit={() => {
                    setIsOpenFeedbackSuccessFn(true);
                    setIsOpenFeedbackFn(false);
                }}
            />
        </Dialog>
    );
};
